import React from 'react';
import Glyph from '@uds/glyphs';
import { Heading04 } from '@uds/typography';
import { Colorways } from '@uds/colorway';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';

import { getClassNames } from './QuestionHeader.stylesheet';

interface OuterProps {
  hBaseline: number;
  question: ShortcodeProps;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  colorway: Colorways;
  active?: boolean;
  duration: number;
  isFirst?: boolean;
}

export const PureHeader = ({ hBaseline, question, onClick, colorway, active }: OuterProps) => {
  const icon = active ? 'chevronUp' : 'chevronDown';
  const classNames = getClassNames({ isActive: active });

  return (
    <button className={classNames.root} onClick={onClick}>
      <Heading04 depth={hBaseline + 1} className={classNames.title}>
        <Shortcode code={question} against={colorway} />
      </Heading04>
      <span className={classNames.icon}>
        <Glyph name={icon} />
      </span>
    </button>
  );
};
PureHeader.displayName = 'Header';

export default PureHeader;
